<template>
    <li class="nav-item cursor-pointer position-relative" v-tooltip="{ content: tooltipText, placement: 'right' }">
        <a class="nav-link" :class="{ active: active }" href="#">
            <i :class="icon"></i>
        </a>
        <span v-if="cBadgeCount && cBadgeType && cBadgeCount > 0" :class="{'current-ai': cBadgeType == 'AI'}" class="position-absolute badge rounded-pill me-1">
            {{ cBadgeCount }}
        </span>
    </li>
</template>
<script>
export default {
    name: 'ButtonNavBarUser',
    props: {
        icon: {
            type: String,
            default: 'ri-pie-chart-line'
        },
        tooltipText: {
            type: String,
            default: ''
        },
        active: {
            type: Boolean,
            default: false
        },
        badgeCount: {
            type: Number,
            default: null
        },
        badgeType: {
            type: String,
            default: null
        }

    },
    data() {
        return {
            __debugForceBadgeType: null,
            __debugForceBadgeCount: null,
        };
    },
    computed: {
        cBadgeType() {
            return this.__debugForceBadgeType == null ? this.badgeType : this.__debugForceBadgeType;
        },
        cBadgeCount() {
            return this.__debugForceBadgeCount == null ? this.badgeCount : this.__debugForceBadgeCount;
        }
    }
}
</script>
<style scoped>
.current-ai {
    background-color: #d947ef;
    color: #fff;
    font-size: 10px;
    padding: 4px 6px;
    font-weight: 700;
    animation: pulse-purple 1.5s infinite;
    top: 0px;
    right: -7px;
    z-index: 3;
}

@keyframes pulse-purple {
    0% {
        box-shadow: 0 0 0 0 rgba(124, 58, 237, 0.6);
    }
    70% {
        box-shadow: 0 0 0 8px rgba(124, 58, 237, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(124, 58, 237, 0);
    }
}

</style>